import { render } from "./ClustorsList.vue?vue&type=template&id=7d29f15a&scoped=true"
import script from "./ClustorsList.vue?vue&type=script&lang=js"
export * from "./ClustorsList.vue?vue&type=script&lang=js"

import "./ClustorsList.vue?vue&type=style&index=0&id=7d29f15a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d29f15a"]])

export default __exports__